import { Injectable } from '@angular/core';

import { NavController } from '@ionic/angular';
import { UnifiedLoginService } from './unified-login.service';
import { UnifiedLoginStorageService } from './unified-login-storage.service';
import { CanActivateFn, UrlTree } from '@angular/router';

/**
 * #deprecated
 * In Angular 16+, CanActivate, CanDeactivate, etc. are technically deprecated, but they still work just fine.
 * will move to functional guards in angular 18 migration
 */
@Injectable({
  providedIn: 'root',
})
export class UnifiedLoginGuard {
  constructor(
    public navContoller: NavController,
    private unifiedLoginStorage: UnifiedLoginStorageService,
    private unifiedLoginService: UnifiedLoginService,
  ) {}

  canActivate: CanActivateFn = async (): Promise<boolean | UrlTree> => {
    return this.unifiedLoginStorage.init().then(() =>
      this.unifiedLoginService.isUserAuthenticated(this.unifiedLoginService.loginProxyFromUrl).then((r) => {
        switch (r) {
          case 'SUCCESS':
            return true;
          case 'NO_PERMISSION':
            return false;
          case 'TIMEOUT':
            return false;
          case 'FAILED':
            this.unifiedLoginService.redirectToLogin();
        }
        return false;
      }),
    );
  };
}
